'use client';

import { memo } from 'react';
import PropTypes from 'prop-types';

import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import useScreen from 'hooks/useScreen';

const DesktopOnly = ({ children, fallback = null }) => {
  const isBrowser = useIsBrowser();
  const { isDesktop } = useScreen();

  // In new Consumer app, to prevent SSR bug always render on server. After components
  // are mounted in browser, we should conditionally only render when on desktop device.
  return (isNewConsumerApp && !isBrowser) || isDesktop ? children : fallback;
};

DesktopOnly.propTypes = {
  children: PropTypes.node,
};

export default memo(DesktopOnly);
